import * as React from "react"

const SvgGripDots = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 20.472q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 9 17.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14A1.56 1.56 0 0 1 9 20.473Zm6 0q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 15 17.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14a1.56 1.56 0 0 1-1.141.475m-6-6q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 9 11.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14A1.56 1.56 0 0 1 9 14.473Zm6 0q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 15 11.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14a1.56 1.56 0 0 1-1.141.475m-6-6q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 9 5.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14A1.56 1.56 0 0 1 9 8.473Zm6 0q-.666 0-1.14-.474a1.56 1.56 0 0 1-.475-1.14q0-.667.474-1.142A1.56 1.56 0 0 1 15 5.242q.666 0 1.14.474.475.475.475 1.141 0 .667-.474 1.14A1.56 1.56 0 0 1 15 8.473Z" />
  </svg>
)
export default SvgGripDots
